<template>
	<div>
		<a
		class="btn mb-2 mr-2"
		:class="getClassStr()"
		@click="field.value = !field.value"
		> 
			{{ field.question }}
			<span class="btn btn-primary btn-xs text-sm" @click="toggleInfo" v-if="hasInfo">Show Details</span>
		</a>
        <small 
            v-if="requiredIncomplete"
            class="ml-1" style="color:#FF0000"    
        >
            {{  $t('required')}}
        </small>
		<div v-if="field.description" v-html="field.description"></div>
		<div v-if="(this.viewinfo && field.info)" v-html="field.info" class="mr-2 text-sm"></div>
	</div>
</template>

<script>
export default {
	props: ['field', 'readonly','viewAs'],
    data() {
		return {
			'viewinfo': false
		}
	},
	methods: {
		getClassStr() {
			const classArr = [''];
			if(this.field.value) {
				if(this.field.cssclass) {
					classArr.push(`btn-on ${this.field.cssclass}`);
				} else {
					classArr.push('btn-on');
				}
			} else {
				classArr.push('btn-off');
			}
			if(this.readonly) {
				classArr.push('disabled');
			}

			return classArr.join(' ');
		},
        toggleInfo() {
        	this.viewinfo = !this.viewinfo;
        }
	},
    computed: {
        requiredIncomplete() {
            return (this.field.permission.includes(this.viewAs) || this.field.permission.length === 0) 
            && this.field.required && !this.field.value;
        },
        hasInfo() {
        	if(this.field.info){
        		return true;
        	}
        	return false;
        }
    }
   
};
</script>
